// extracted by mini-css-extract-plugin
module.exports = {"rich-text":"richTextArea_rich-text__PiEdc"};